import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=69e5e057"
import script from "./shops.vue?vue&type=script&lang=ts"
export * from "./shops.vue?vue&type=script&lang=ts"
import style0 from "./shops.vue?vue&type=style&index=0&id=69e5e057&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShopsList: require('/codebuild/output/src3458403893/src/acredo-website/components/shops/shopsList.vue').default,ShopAppointmentButton: require('/codebuild/output/src3458403893/src/acredo-website/components/shopAppointment/shopAppointmentButton.vue').default,ElementHeadline: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementHeadline.vue').default,HtmlBrandButton: require('/codebuild/output/src3458403893/src/acredo-website/components/html/htmlBrandButton.vue').default,ElementVideoBanner: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementVideoBanner.vue').default,ElementSeoText: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementSeoText.vue').default,Breadcrumb: require('/codebuild/output/src3458403893/src/acredo-website/components/Breadcrumb.vue').default,MetaTitle: require('/codebuild/output/src3458403893/src/acredo-website/components/meta/MetaTitle.vue').default})
